<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="4">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-store"></i>&nbsp;COMPRAS PARA {{ $store.getters.get_campu.name }}</span>
            <button
              @click="returnHome"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12">
                <CInput
                  label="Ruc"
                  type="text"
                  disabled
                  v-model="$store.getters.get_campu.ruc"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12">
                <cSelectForm
                  label="Proveedores"
                  placeholder="Seleccione proveedor"
                  :options="data_provider"
                  :value.sync="purchase.provider_id"
                />
              </CCol>

              <CCol xs="12" sm="6" md="12" lg="12" xl="6">
                <CInput
                  label="Fecha de compra"
                  type="date"
                  v-model="fechaCompra"
                />
              </CCol>
              <CCol xs="12" sm="6" md="12" lg="12" xl="6">
                <cSelectForm
                  label="Tipo de Comprobante"
                  placeholder="Seleccione.. "
                  :options="data_document_type"
                  :value.sync="purchase.document_type_id"
                />
              </CCol>
              <CCol xs="12" sm="6" md="12" lg="12" xl="6">
                <CInput
                  label="N° de documento"
                  placeholder="Digite N° documento"
                  v-model="purchase.document"
                />
              </CCol>
              <!-- <CCol xs="12" sm="6" md="12" lg="12" xl="6">
                <cSelectForm
                  label="Medio de Pago"
                  placeholder="Seleccione.."
                  :options="data_method_payment"
                  :value.sync="purchase.method_payment_id"
                />
              </CCol> -->
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="8">
        <CCard>
          <CCardHeader>
            <span><i class="fas fa-coins"></i>&nbsp;Productos e Insumos</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <cSelectForm
                  label="Tipo"
                  placeholder="Seleccione tipo"
                  :options="data_type"
                  :value.sync="newProduct.type"
                  @change="saveType"
                />
              </CCol>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <cSelectForm
                  v-if="newProduct.type == 'producto'"
                  label="Producto"
                  placeholder="Seleccione producto"
                  :options="data_product"
                  :value.sync="newProduct.product.id"
                  @change="saveProduct"
                />
                <cSelectForm
                  v-if="newProduct.type == 'insumo'"
                  label="Insumo"
                  placeholder="Seleccione insumo"
                  :options="data_insumo"
                  :value.sync="newProduct.insumo.id"
                  @change="saveInsumo"
                />
              </CCol>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <cSelectForm
                  label="Unidad Base"
                  placeholder="Seleccione Unidad Base"
                  :options="data_unit"
                  :value.sync="newProduct.unit.id"
                  @change="saveUnit"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="12" sm="6" md="3" lg="3" xl="3">
                <CInput
                  label="Precio"
                  placeholder="Digite precio"
                  v-model="newProduct.price"
                  @keyup="validatePositive('price')"
                  @keypress.enter="mtdNextFocus(1)"
                />
              </CCol>
              <CCol xs="12" sm="6" md="3" lg="3" xl="3">
                <CInput
                  label="Cantidad"
                  type="number"
                  placeholder="cantidad"
                  v-model="newProduct.quantity"
                  @change="validatePositive('quantity')"
                  ref="inputQuantity"
                  @keypress.enter="mtdNextFocus(2)"
                />
              </CCol>
              <CCol xs="12" sm="6" md="3" lg="3" xl="3">
                <cSelectForm
                  label="Tipo Descuento"
                  placeholder="Seleccione"
                  :options="data_discount_type"
                  :value.sync="newProduct.discount_type"
                />
              </CCol>
              <CCol xs="12" sm="6" md="3" lg="3" xl="3">
                <CInput
                  :label="
                    newProduct.discount_type == 'percentage'
                      ? 'Descuento (%)'
                      : 'Descuento (S/)'
                  "
                  placeholder="0.00"
                  v-model="newProduct.discount_amount"
                  @keyup="validatePositive('discount_amount')"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <CInput
                  label="Sub-Total"
                  :value="calculateItemSubtotal"
                  readonly
                />
              </CCol>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <CInput
                  label="Descuento Aplicado"
                  :value="calculateItemDiscount"
                  readonly
                />
              </CCol>
              <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                <CInput label="Total" :value="calculateItemTotal" readonly />
              </CCol>
            </CRow>
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                class="d-flex justify-content-end mt-2"
              >
                <button
                  @click="addProduct"
                  type="button"
                  class="btn btn-sm text-white font-bold"
                  style="background: #57cc99"
                >
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardHeader class="d-flex justify-content-start">
            <span><i class="fa fa-user"></i>&nbsp; Lista de productos </span>
          </CCardHeader>
          <CCardBody>
            <div class="table-responsive">
              <table
                id="dataTableLists"
                class="table table-sm table-striped table-hover table-bordered dt-responsive nowrap"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th width="60">N°</th>
                    <th>Tipo</th>
                    <th>Producto/Insumo</th>
                    <th>Unidad Base</th>
                    <th>Precio</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                    <th>Descuento</th>
                    <th>Total</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in productList" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <span
                        :class="
                          product.type == 'producto'
                            ? 'badge badge-success'
                            : 'badge badge-info'
                        "
                      >
                        {{ product.type == "producto" ? "Producto" : "Insumo" }}
                      </span>
                    </td>
                    <td>
                      {{
                        product.type == "producto"
                          ? product.product.name
                          : product.insumo.name
                      }}
                    </td>
                    <td>{{ product.unit.name }}</td>
                    <td>{{ product.price }}</td>
                    <td>{{ product.quantity }}</td>
                    <td>{{ (product.price * product.quantity).toFixed(2) }}</td>
                    <td>
                      <span v-if="product.discount_amount > 0">
                        {{
                          product.discount_type == "percentage"
                            ? product.discount_amount + "%"
                            : "S/ " +
                              parseFloat(product.discount_amount).toFixed(2)
                        }}
                        <br />
                        <small class="text-muted"
                          >(S/
                          {{
                            getProductDiscountValue(product).toFixed(2)
                          }})</small
                        >
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="font-weight-bold">
                      {{ getProductTotal(product).toFixed(2) }}
                    </td>
                    <td class="text-center">
                      <button
                        @click="removeProduct(index)"
                        class="btn btn-danger btn-sm"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="8" class="text-right font-bold">Total</td>
                    <td class="font-bold">{{ calculateTotal.toFixed(2) }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                class="d-flex justify-content-end"
              >
                <button
                  @click="check_action"
                  type="button"
                  class="btn btn-sm text-white"
                  style="background: #39f"
                  :disabled="!cpButton"
                >
                  <i class="fas fa-save"></i> Guardar
                </button>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import cSelectForm from "../../../../shared/inputs/cSelect.vue";

export default {
  name: "purchases",
  components: {
    cSelectForm,
  },
  data() {
    return {
      prefix: "purchases",
      data_provider: [],
      data_document_type: [],
      data_method_payment: [],
      data_product: [],
      data_insumo: [],
      data_unit: [],
      data_type: [
        { label: "Producto", value: "producto" },
        { label: "Insumo", value: "insumo" },
      ],
      data_discount_type: [
        { label: "Monto Fijo", value: "fixed" },
        { label: "Porcentaje", value: "percentage" },
      ],
      fechaCompra: moment().format("YYYY-MM-DD"),
      purchase: {
        id: "",
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        method_payment_id: "",
        document_type_id: "",
        provider_id: "",
        document: "",
        total: "",
        date: "",
      },
      newProduct: {
        type: "producto",
        product: {
          id: "",
          name: "",
        },
        insumo: {
          id: "",
          name: "",
        },
        unit: {
          id: "",
          name: "",
        },
        price: "",
        quantity: 1,
        subtotal: 0,
        discount_type: "fixed",
        discount_amount: 0,
      },
      productList: [],
    };
  },
  computed: {
    calculateItemSubtotal() {
      return (this.newProduct.price * this.newProduct.quantity).toFixed(2);
    },
    calculateItemDiscount() {
      const subtotal = this.newProduct.price * this.newProduct.quantity;
      let discount = 0;

      if (this.newProduct.discount_type == "percentage") {
        discount =
          (subtotal * parseFloat(this.newProduct.discount_amount || 0)) / 100;
      } else {
        discount = parseFloat(this.newProduct.discount_amount || 0);
      }

      return discount.toFixed(2);
    },
    calculateItemTotal() {
      const subtotal = parseFloat(this.calculateItemSubtotal);
      const discount = parseFloat(this.calculateItemDiscount);
      return (subtotal - discount).toFixed(2);
    },
    calculateSubtotal() {
      return (this.newProduct.subtotal = (
        this.newProduct.price * this.newProduct.quantity
      ).toFixed(2));
    },
    calculateTotal() {
      return this.productList.reduce((total, product) => {
        const subtotal = product.price * product.quantity;
        let discount = 0;

        if (product.discount_type == "percentage") {
          discount =
            (subtotal * parseFloat(product.discount_amount || 0)) / 100;
        } else {
          discount = parseFloat(product.discount_amount || 0);
        }

        return total + (subtotal - discount);
      }, 0);
    },
    cpButton() {
      // Permitir method_payment_id == 0 (NINGUNO) como válido
      const isValid =
        this.purchase.provider_id &&
        // this.purchase.method_payment_id != "" &&
        // this.purchase.method_payment_id != null &&
        this.purchase.document_type_id &&
        this.purchase.document &&
        this.purchase.total &&
        this.productList.length > 0;

      return isValid;
    },
  },
  watch: {
    productList: {
      handler() {
        this.purchase.total = this.calculateTotal.toFixed(2);
      },
      deep: true,
    },
  },
  created() {
    this.showProvider();
    this.showDocumentType();
    this.showMethodPayment();
    // this.showBaseUnits();
    this.showInsumosAndProducts();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    showProvider() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byProvider/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.data) {
            response.data.data.forEach((arr) => {
              const { Id, name } = arr;
              this.data_provider.push({
                label: name,
                value: Id,
              });
            });
          }
        })
        .catch((errors) => {});
    },
    showDocumentType() {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/byDocumentType",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_document_type.push({
              label: name,
              value: id,
            });
          });
        })
        .catch((errors) => {});
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_method_payment = [];
          if (response.data && response.data.data) {
            response.data.data.forEach((arr) => {
              const { Id, name } = arr;
              this.data_method_payment.push({
                label: name,
                value: Id,
              });
            });
          }
        })
        .catch((errors) => {});
    },
    showInsumosAndProducts() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byInsumosAndProducts/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_product = [];
          this.data_insumo = [];          
          // Cargar productos (ahora deduplicados por nombre)
          if (response.data.products) {
            response.data.products.forEach((arr) => {
              const { id, name } = arr;
              this.data_product.push({
                label: name,
                value: id,
                unit: arr.unit,
              });
            });
          }

          // Cargar insumos
          if (response.data.insumos) {
            response.data.insumos.forEach((arr) => {
              const { id, name, price_cost } = arr;
              this.data_insumo.push({
                label: name,
                value: id,
                price_cost: price_cost,
                unit:arr.unit
              });
            });
          }
        })
        .catch((errors) => {});
    },
    showBaseUnits() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byBaseUnits/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_unit = [];

          if (response.data.data) {
            response.data.data.forEach((arr) => {
              const { Id, name } = arr;
              this.data_unit.push({
                label: name,
                value: Id,
              });
            });
          }
        })
        .catch((errors) => {});
    },
    saveType() {
      // Limpiar selecciones cuando cambia el tipo
      this.newProduct.product.id = "";
      this.newProduct.product.name = "";
      this.newProduct.insumo.id = "";
      this.newProduct.insumo.name = "";
      this.newProduct.unit.id = "";
      this.newProduct.unit.name = "";
    },
    saveProduct() {
      const productId = this.newProduct.product.id;
      const product = this.data_product.find((p) => p.value == productId);
      if (product) {
        this.newProduct.product.name = product.label.split(" (")[0];
        this.data_unit = product.unit.map((u) => ({
          label: u.name,
          value: u.id,
        }));
      } else {
        this.data_unit = [];
      }
    },
    saveInsumo() {
      this.data_unit = [];
      const insumo_id = this.newProduct.insumo.id;
      const insumo = this.data_insumo.find((p) => p.value == insumo_id);
      if (insumo) {
        this.newProduct.insumo.name = insumo.label.split(" (")[0];
        this.data_unit.push({
          label: insumo.unit.name,
          value: insumo.unit.id,
        });
      } else {
        this.data_unit = [];
      }
    },
    saveUnit() {
      const unit_id = this.newProduct.unit.id;
      this.data_unit.forEach((arr) => {
        if (arr.value == unit_id) {
          this.newProduct.unit.name = arr.label;
        }
      });
    },
    getProductDiscountValue(product) {
      const subtotal = product.price * product.quantity;
      let discount = 0;

      if (product.discount_type == "percentage") {
        discount = (subtotal * parseFloat(product.discount_amount || 0)) / 100;
      } else {
        discount = parseFloat(product.discount_amount || 0);
      }

      return discount;
    },
    getProductTotal(product) {
      const subtotal = product.price * product.quantity;
      const discount = this.getProductDiscountValue(product);
      return subtotal - discount;
    },
    addProduct() {
      const isValidProduct =
        this.newProduct.type == "producto" && this.newProduct.product.name;
      const isValidInsumo =
        this.newProduct.type == "insumo" && this.newProduct.insumo.name;

      if (
        (isValidProduct || isValidInsumo) &&
        this.newProduct.unit.name &&
        this.newProduct.price > 0
      ) {
        const subtotal_base = this.newProduct.price * this.newProduct.quantity;
        const discount_value = parseFloat(this.calculateItemDiscount);

        const productToAdd = {
          type: this.newProduct.type,
          product:
            this.newProduct.type == "producto"
              ? {
                  id: this.newProduct.product.id,
                  name: this.newProduct.product.name,
                }
              : null,
          insumo:
            this.newProduct.type == "insumo"
              ? {
                  id: this.newProduct.insumo.id,
                  name: this.newProduct.insumo.name,
                }
              : null,
          unit: {
            id: this.newProduct.unit.id,
            name: this.newProduct.unit.name,
          },
          price: this.newProduct.price,
          quantity: this.newProduct.quantity,
          subtotal: (subtotal_base - discount_value).toFixed(2),
          discount_type: this.newProduct.discount_type,
          discount_amount: parseFloat(this.newProduct.discount_amount || 0),
        };
        this.productList.push(productToAdd);

        // Limpiar formulario
        this.newProduct.product.name = "";
        this.newProduct.product.id = "";
        this.newProduct.insumo.name = "";
        this.newProduct.insumo.id = "";
        this.newProduct.unit.id = "";
        this.newProduct.unit.name = "";
        this.newProduct.price = "";
        this.newProduct.quantity = 1;
        this.newProduct.discount_type = "fixed";
        this.newProduct.discount_amount = 0;
        this.purchase.total = this.calculateTotal.toFixed(2);
      }
    },
    removeProduct(index) {
      Swal.fire({
        title: "¿Desea eliminar el producto?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el usuario confirma, se elimina el producto
          this.productList.splice(index, 1);
          Swal.fire("Eliminado!", "El producto ha sido eliminado.", "success");
        }
      });
    },
    check_action: function () {
      // Verifica si hay un producto/insumo seleccionado que no se ha agregado a la lista
      const hasProductSelected =
        this.newProduct.type == "producto" && this.newProduct.product.id;
      const hasInsumoSelected =
        this.newProduct.type == "insumo" && this.newProduct.insumo.id;

      if (
        hasProductSelected ||
        hasInsumoSelected ||
        this.newProduct.unit.id ||
        this.newProduct.price > 0
      ) {
        const itemType =
          this.newProduct.type == "producto" ? "producto" : "insumo";
        Swal.fire({
          title: `Tienes un ${itemType} seleccionado`,
          text: `Hay un ${itemType} seleccionado que no se ha agregado a la lista. ¿Deseas agregarlo antes de continuar?`,
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: `Agregar ${itemType}`,
          cancelButtonText: "Continuar sin agregar",
        }).then((result) => {
          if (result.dismiss == "close") {
            Swal.close();
          } else if (result.isConfirmed) {
            // Agrega el producto/insumo a la lista
            this.addProduct();
          } else {
            // Si decide continuar sin agregar, envía los datos al backend
            this.mtd_action();
          }
        });
      } else {
        // Si no hay productos/insumos seleccionados sin agregar, envía los datos al backend
        this.mtd_action();
      }
    },
    mtd_action: function () {
      this.purchase.date = this.fechaCompra;
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          purchase: this.purchase,
          purchaseDetail: this.productList,
        },
      })
        .then((response) => {
          let color = "";
          let message = "";
          if (response.statusCode == 200) {
            color = "success";
            message = "REGISTRADO CORRECTAMENTE";
          } else {
            color = "danger";
            message = "error";
          }
          this.fechaCompra = moment().format("YYYY-MM-DD");
          this.purchase = {
            id: "",
            campu_id: this.$store.getters.get_campu.id,
            user_id: this.$store.getters.get__user_id,
            provider_id: "",
            date: "",
            document_type_id: "",
            document: "",
            method_payment_id: "",
            total: "",
          };
          this.productList = [];
          this.newProduct = {
            type: "producto",
            product: {
              id: "",
              name: "",
            },
            insumo: {
              id: "",
              name: "",
            },
            unit: {
              id: "",
              name: "",
            },
            price: "",
            quantity: 1,
            subtotal: 0,
            discount_type: "fixed",
            discount_amount: 0,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    validatePositive(field) {
      if (!event || !event.target) return;

      let sanitizedValue = event.target.value.replace(/[^0-9.]/g, "");
      const decimalCount = sanitizedValue.split(".").length - 1;
      if (decimalCount > 1) {
        sanitizedValue = sanitizedValue.slice(0, -1);
      }
      const decimalIndex = sanitizedValue.indexOf("."); // Limitar a dos decimales
      if (decimalIndex !== -1) {
        const decimalPart = sanitizedValue.substring(decimalIndex + 1);
        sanitizedValue = `${sanitizedValue.substring(
          0,
          decimalIndex
        )}.${decimalPart.substring(0, 2)}`;
      }
      this.newProduct[field] = sanitizedValue;
    },
    mtdNextFocus: function (step) {
      switch (step) {
        case 1:
          this.newProduct.price = parseFloat(this.newProduct.price).toFixed(2);
          const input = this.$refs.inputQuantity;
          input.$el.children[0].focus();
          break;
        case 2:
          this.addProduct();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.table-responsive {
  overflow-x: auto;
}
</style>
